export const AnalyticsQueryKeys = {
  all: ['reports'],
  homeKpis: ['home-kpis'],
  details: () => [...AnalyticsQueryKeys.all, 'detail'],
  detail: (id) => [...AnalyticsQueryKeys.details(), id],
  pagination: (page, filters = {}) => {
    // Create a consistent, serializable representation of filters
    const filterKey = Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}:${value}`)
      .sort()
      .join('|');

    return [
      ...AnalyticsQueryKeys.all,
      'pagination',
      page.toString(),
      filterKey,
    ];
  },
  infinite: () => [...AnalyticsQueryKeys.all, 'infinite'],
};
